import React, { useMemo } from 'react'
import { Table, MobileTable } from '../../../components'
// import makeData from '../makeData'

const data = [
  {
    id: 1,
    subject: 'Forum Koordinasi Pendidikan',
    from: 'BNPT, Kementerian Pendidikan',
  },
  {
    id: 2,
    subject: 'Forum Koordinasi Deradikalisasi',
    from: 'BNPT, UNODC, CDS',
  }
]

const Inbox = () => {
  const tableData = useMemo(() => data/* makeData(47) */, [])
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Subject',
        accessor: 'subject',
      },
      {
        Header: 'From',
        accessor: 'from',
      },
    ],
    []
  )

  return (
    <div>
      {/* Desktop Table */}
      <div className="hidden lg:block mb-12">
        <Table
          data={tableData}
          columns={tableColumns}
          withCheckbox
        />
      </div>

      {/* Mobile Table */}
      <div className="lg:hidden mobile-fullwidth mb-12">
        <MobileTable
          data={tableData}
          columns={tableColumns}
          withCheckbox
        />
      </div>
    </div>
  )
}

export { Inbox }
